// @ts-nocheck 5b334f5d
import createBookButtonWidget from './createBookButtonWidget';
export default ({ editorAPI }) =>
  createBookButtonWidget({
    editorAPI,
  });
